<template>

    <div v-if="showOverlay" class="overlay">
        <div class="progress-container">
            <h2 style="color: white;">Generating Your Birth Chart Interpretation...</h2>
            <p class="status-text">{{ currentStatus }}</p>
            <div class="progress-bar">
                <div class="progress-fill" :style="{ width: progressWidth }">
                </div>
            </div>
        </div>
    </div>		

    <div class="small-screen-wrapper" v-show="!pageLoading">
        <div class="basic-details">
            <ShowClientInfo :criteria="criteria" :horoscope="horoscope" @activeMenuItem="activateMenuItem" />
        </div>
        <div class="vertical-menu">

            <!-- Natal Chart -->
            <table id="natal-chart" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('natal-chart')" v-bind:class="{row_selected:activeSection == 'natal-chart',row_not_selected:activeSection != 'natal-chart'}">
                    <td>Natal Chart</td>
                </tr>
                <tr>
                    <td v-show="activeSection == 'natal-chart'">
                        <div class="natal-chart-images">
                            <ShowNatalChartImages :horoscope="horoscope" />
                        </div>
                        <div class="planets-details">
                            <template v-if="criteria.topocentricPlanets == 1">
                                <ShowPlanetsTable :horoscope="horoscope" :planetsTitle="'Topocentric Natal Planets'" />
                            </template>
                            <template v-else>
                                <ShowPlanetsTable :horoscope="horoscope" :planetsTitle="'Natal Planets'" />
                            </template>
                        </div>
                    </td>
                </tr>
            </table>
            <!-- Divisional Charts -->
            <table id="divisional-chart" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('divisional-chart')" v-bind:class="{row_selected:activeSection == 'divisional-chart',row_not_selected:activeSection != 'divisional-chart'}">
                    <td>Divisional Chart</td>
                </tr>
                <tr>
                    <td v-show="activeSection == 'divisional-chart'">
                        <div class="natal-chart-images">
                            <ShowDivisionalChartImages :horoscope="horoscope" />
                        </div>
                    </td>
                </tr>
            </table>
            <!-- Bhava Chart -->
            <table id="bhava-chart" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('bhava-chart')" v-bind:class="{row_selected:activeSection == 'bhava-chart',row_not_selected:activeSection != 'bhava-chart'}">
                    <td>Houses</td>
                </tr>
                <tr>
                    <td v-show="activeSection == 'bhava-chart'">
                        <div class="bhava-chart-images">
                            <ShowBhavaChart :criteria="criteria" :horoscope="horoscope" />
                        </div>
                    </td>
                </tr>
            </table>
            <!-- Aspects & Conjunctions -->
            <table id="aspect-conjunction" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('aspect-conjunction')" v-bind:class="{row_selected:activeSection == 'aspect-conjunction',row_not_selected:activeSection != 'aspect-conjunction'}">
                    <td>Aspects &amp; Conjunctions</td>
                </tr>
                <tr>
                    <td v-show="activeSection == 'aspect-conjunction'">
                        <div class="aspects-info">
                            <ShowAspectsInfo :horoscope="horoscope" />
                        </div>
                        <div class="conjunctions-info">
                            <ShowConjunctionsInfo :horoscope="horoscope" />
                        </div>
                    </td>
                </tr>
            </table>
            <!-- Vimsottari Dasa -->
            <table id="filtered-vimsottari-dasa" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('filtered-vimsottari-dasa')" v-bind:class="{row_selected:activeSection == 'filtered-vimsottari-dasa',row_not_selected:activeSection != 'filtered-vimsottari-dasa'}">
                    <td>Vimsottari Dasa</td>
                </tr>
                <tr>
                    <td v-if="activeSection == 'filtered-vimsottari-dasa'">
                        <div class="vimsottari-dasa-details">
                            <ShowFilteredVimsottariDasas :horoscope="horoscope" />
                        </div>
                    </td>
                </tr>
            </table>
            <!-- Natal Panchanga -->
            <table id="natal-panchanga" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('natal-panchanga')" v-bind:class="{row_selected:activeSection == 'natal-panchanga',row_not_selected:activeSection != 'natal-panchanga'}">
                    <td>Natal Panchanga</td>
                </tr>
                <tr>
                    <td v-show="activeSection == 'natal-panchanga'">
                        <div class="panchanga-details">
                            <ShowPanchangaInfo :horoscope="horoscope" />
                        </div>
                    </td>
                </tr>
            </table>
            <!-- Summary Chart -->
            <table id="summary-chart" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('summary-chart')" v-bind:class="{row_selected:activeSection == 'summary-chart',row_not_selected:activeSection != 'summary-chart'}">
                    <td>Basic Chart</td>
                </tr>
                <tr>
                    <td v-show="activeSection == 'summary-chart'">
                        <div align="center" class="download-chart">
                            <div align="center">Summary Chart</div>
                            <br/>
                            <button @click="downloadSummaryPDF()">&nbsp;View Chart&nbsp;</button>
                            <br/><br/>
                        </div>
                    </td>
                </tr>
            </table>

            <!-- Free Birth Chart Interpretation -->
            <table id="basic-natal-chart-report" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('basic-natal-chart-report')" v-bind:class="{row_selected:activeSection == 'basic-natal-chart-report',row_not_selected:activeSection != 'basic-natal-chart-report'}">
                    <td>Free Birth Chart Interpretation</td>
                </tr>
                <tr>
                    <!--
                    <td v-show="activeSection == 'basic-natal-chart-report'">
                        <div align="center" class="download-chart">
                            <div align="center">Download / View Your Free Birth Chart Interpretation.</div>
                            <br/>
                            <button @click="downloadFreeBirthChartInterepreation()">&nbsp;Free Chart Interpretation&nbsp;</button>
                            <br/><br/>
                        </div>
                    </td>                    
                    -->
                    <td v-show="activeSection == 'basic-natal-chart-report'">
                        <div align="center" class="download-chart">
                            <div align="center" style="line-height: 1.25;">
                                Your <b>personalized Vedic astrology reports</b> are crafted using authentic principles and now available at our <b>dedicated portal</b>.            
                            </div>
                            <br/>
                            <a
                                :href="reportUrl"
                                target="_blank"
                                rel="noopener"
                                class="report-cta-button"
                                >
                                VedicAstrologyReport.com →
                            </a>                          
                            <br/><br/>
                        </div>
                    </td>
                </tr>
            </table>

            <!-- Essential Chart FREE -->
            <!--
            <table id="detailed-chart" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('detailed-chart')" v-bind:class="{row_selected:activeSection == 'detailed-chart',row_not_selected:activeSection != 'detailed-chart'}">
                    <td>Essential Chart</td>
                </tr>
                <tr>
                    <td v-show="activeSection == 'detailed-chart'">
                        <div align="center" class="download-chart" >
                            <div align="center">Essential Natal Chart</div>
                            <br/>
                            <button @click="downloadDetailedPDF()">&nbsp;View Chart&nbsp;</button>
                            <br/><br/>
                        </div>
                    </td>
                </tr>
            </table>
            -->
            <!-- Essential Chart PAID -->
            <table id="detailed-chart" width="100%" cellspacing="0" cellpadding="0">
                <tr @click="showSection('detailed-chart')" v-bind:class="{row_selected:activeSection == 'detailed-chart',row_not_selected:activeSection != 'detailed-chart'}">
                    <td>Essential Chart</td>
                </tr>
                <tr>
                    <td v-show="activeSection == 'detailed-chart'">
                        <div align="center" class="download-chart" >
                            <MobilePurchaseCompleteNatalChart :criteria="criteria" />
                        </div>
                    </td>
                </tr>
            </table>
            <!-- Donation -->
            <!--
            <table width="100%" cellspacing="0" cellpadding="0" border="1">
                <tr class="row_not_selected">
                    <td>
                        <form action="https://www.paypal.com/donate" method="post" target="_top">
                            <input type="hidden" name="hosted_button_id" value="DAJNLMZNENE2Q" />
                            <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                            <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
                        </form>
                    </td>
                </tr>
            </table>
            -->
            <!-- Empty Row -->
            <table width="100%" cellspacing="0" cellpadding="0">
                <tr class="row_not_selected">
                    <td>&nbsp;&nbsp;</td>
                </tr>
            </table>
        </div>
        <!-- Donation -->
        <div align="center" class="donation" v-if="activeSection != 'detailed-chart'">
            <form action="https://www.paypal.com/donate" method="post" target="_top">
                <input type="hidden" name="hosted_button_id" value="DAJNLMZNENE2Q" />
                <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                <img alt="" border="0" src="https://www.paypal.com/en_US/i/scr/pixel.gif" width="1" height="1" />
            </form>
        </div>
    </div>
</template>

<script>
import { queryString, criteriaToken, generatePaidNatalChartKey } from '@/util.js'
import HTTP from '@/http-axios';
import ApiBaseUrl from '@/http-api-base-url'
import ShowClientInfo from '@/components/small-screen-natal-chart/ShowClientInfo'
import ShowNatalChartImages from '@/components/small-screen-natal-chart/ShowNatalChartImages'
import ShowDivisionalChartImages from '@/components/small-screen-natal-chart/ShowDivisionalChartImages'
import ShowBhavaChart from '@/components/small-screen-natal-chart/ShowBhavaChart'
import ShowPanchangaInfo from '@/components/small-screen-natal-chart/ShowPanchangaInfo'
import ShowPlanetsTable from '@/components/ShowPlanetsTable'
import ShowVimsottariDasas from '@/components/small-screen-natal-chart/ShowVimsottariDasas'
import ShowFilteredVimsottariDasas from '@/components/small-screen-natal-chart/ShowFilteredVimsottariDasas'
import ShowAspectsInfo from '@/components/small-screen-natal-chart/ShowAspectsInfo'
import ShowConjunctionsInfo from '@/components/small-screen-natal-chart/ShowConjunctionsInfo'
import ShowCurrentChartImages from '@/components/small-screen-natal-chart/ShowCurrentChartImages'
import MobilePurchaseCompleteNatalChart from '@/components/small-screen-natal-chart/MobilePurchaseCompleteNatalChart'
import ViewInterpretationReports from '../../views/ViewInterpretationReports.vue';
import FreeFoundationalReport from '../../views/FreeFoundationalReport.vue';
import PurchaseHouseAnalysisReport from '../../views/PurchaseHouseAnalysisReport.vue';
import PurchaseNakshatraInfluenceReport from '../../views/PurchaseNakshatraInfluenceReport.vue';
import PurchaseMahadashaAnalysisReport from '../../views/PurchaseMahadashaAnalysisReport.vue';
import PurchasePlanetaryPositionsReport from '../../views/PurchasePlanetaryPositionsReport.vue';


export default {
	components: { ShowClientInfo, ShowPanchangaInfo, ShowNatalChartImages, ShowDivisionalChartImages, ShowCurrentChartImages, ShowBhavaChart, 
				  ShowPlanetsTable, ShowAspectsInfo, ShowConjunctionsInfo, ShowVimsottariDasas, ShowFilteredVimsottariDasas, 
                  MobilePurchaseCompleteNatalChart, ViewInterpretationReports, FreeFoundationalReport, PurchasePlanetaryPositionsReport,
                  PurchaseHouseAnalysisReport, PurchaseNakshatraInfluenceReport, PurchaseMahadashaAnalysisReport  },
	props: {
		criteria : {
			type: Object
		}
	},
	data() {
		return {
			activeSection: '',
            reportType: 'natal-chart',
			horoscope: {},
			pageLoading: false,
			showOverlay: false,
			steps: [
				{ text: "Analyzing Ascendant Position... ", delay: 1 },
				{ text: "Analyzing Planetary Positions... ", delay: 1 },
				{ text: "Analyzing House Lord Positions... ", delay: 1 },
				{ text: "Finalizing Report...", delay: 1 }
			],
			currentStep: 0,
			progressWidth: "0%",
			currentStatus: "Initializing...",
            reportUrl: "",
		}
	},
	created() {
		this.activeSection = ''		
        this.reportUrl =  'https://www.vedicastrologyreport.com?' + this.queryString(this.criteria);        
		this.getHoroscope()
	},
	methods: {
		showSection(selectedSection) {

            console.log(selectedSection)

			if ( selectedSection == this.activeSection ) {

                // Clear the selection
				this.activeSection = ''

			} else {

                // New selection
				this.activeSection = selectedSection;	

                // Scroll to the selection
                let table = document.getElementById(selectedSection);
                console.log('selected table: ' + table);
                if (table) {
                    // If there are ongoing CSS or JavaScript animations, scrollIntoView() might get overridden
                    // Delay to ensure animations finish
                    setTimeout( () => { table.scrollIntoView({ behavior: "instant", block: "start" }); }, 100);
                } 

			}

		},
		showReport( selectedReportType ) {
            console.log('reportType :' + selectedReportType)
            this.reportType = selectedReportType;

            let table = document.getElementById("chart-interpretations");
            if (table) {
                // If there are ongoing CSS or JavaScript animations, scrollIntoView() might get overridden
                // Delay to ensure animations finish
                setTimeout( () => { table.scrollIntoView({ behavior: "instant", block: "start" }); }, 100);
            } 
		},
		ApiBaseUrl: function() {
			return ApiBaseUrl();
		},
        queryString: function (obj) {
            return queryString(obj);
        },
        getCriteriaToken: function() {
            return criteriaToken(this.criteria);
        },
        getPaidNatalChartKey: function() {
            return generatePaidNatalChartKey(this.criteria);
        },
		getHoroscope: function() {
			this.pageLoading = true
            //this.startProgress();
			HTTP().post('/api/data/horoscope?' + this.queryString(this.criteria))
			.then(response => {
				this.horoscope = response.data
				this.pageLoading = false
			})
			.catch(e => {
				console.log(e)
			})
		},
		activateMenuItem(activeMenuItem) {
			this.$emit('activeMenuItem', activeMenuItem);
		},
		downloadSummaryPDF() {
			HTTP().get(ApiBaseUrl() + '/api/pdf/horoscope_summary?' + this.queryString(this.criteria) + '&ct=' + this.getCriteriaToken(this.criteria), { responseType: 'blob' })
			.then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' })
				const link = document.createElement('a')
				link.href = URL.createObjectURL(blob)
				link.download = new String("VedicAstroChart-Summary" + (this.criteria.client ? " - " + this.criteria.client : ""))
				link.click()
				URL.revokeObjectURL(link.href)
			}).catch(console.error)
		},		
		downloadDetailedPDF() {
			HTTP().get(ApiBaseUrl() + '/api/pdf/horoscope?' + this.queryString(this.criteria) + '&ct=' + this.getPaidNatalChartKey(this.criteria), { responseType: 'blob' })
			.then(response => {
				const blob = new Blob([response.data], { type: 'application/pdf' })
				const link = document.createElement('a')
				link.href = URL.createObjectURL(blob)
				link.download = new String("VedicAstroChart" + (this.criteria.client ? " - " + this.criteria.client : ""))
				link.click()
				URL.revokeObjectURL(link.href)
			}).catch(console.error)
		},
		downloadFreeBirthChartInterepreation() {
            if ( this.horoscope.criteria.criteriaId ) {
                HTTP().get(ApiBaseUrl() + '/api/html/basic/report/download?fileCriteriaId=' + this.horoscope.criteria.criteriaId + '&' + this.queryString(this.horoscope.criteria), { responseType: 'text' })  // text/html response
                .then(response => {
                    const blob = new Blob([response.data], { type: 'text/html' })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = new String("VedicAstroChart-Free-Birth-Chart-Interpretation" + (this.criteria.client ? " - " + this.criteria.client : ""))
                    link.click()
                    URL.revokeObjectURL(link.href)
                })
                .catch(console.error)
		    }        		
        },
		startProgress() {
			this.showOverlay = true;
			this.currentStep = 0;
			this.updateStep(0);
    	},
		updateStep(index) {
			if (index < this.steps.length) {
				this.currentStatus = this.steps[index].text;
				this.progressWidth = `${((index + 1) / this.steps.length) * 100}%`;
				setTimeout(() => this.updateStep(index + 1), this.steps[index].delay * 1000);
			} else {
				setTimeout(() => this.completeProgress(), 1000);
			}
		},
		completeProgress() {
			this.showOverlay = false;
		}				
    }
}
</script>

<style scoped>

.small-screen-wrapper {
	border: 0px solid;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;	
	align-content: center;
}


.row_not_selected {
	cursor: pointer;
	width: 100%;
	background-color: #344E41; 
	color: #FFFFFF; 
	display: block; 
	padding: 12px; 
	text-align: left;
    font-size: 1.5em;
    font-family: sans-serif;
	margin: 1px;
}

.row_selected {
	cursor: pointer;
	width: 100%;
	background-color: #FF9F1C; 
	color: white;
	font-weight: bold;
	display: block; 
	padding: 12px; 
	text-align: left;
    font-size: 1.5em;
    font-family: sans-serif;
	margin: 1px;
}

.vertical-menu {
	width: 100%; /* Set a width if you like */
}

.basic-details {
	border: 0px solid;
	width: 100%;
	padding-bottom: 20px;
}

.panchanga-details {
	border: 0px solid;
	width: 100%;
}

.natal-chart-images {
	width: 100%;
}

.current-chart-images {
	width: 100%;
}

.bhava-chart-images {
	width: 100%;
}

.planets-details {
	padding-top: 20px;
	width: 100%;
}

.aspects-info {
	width: 100%;
}

.conjunctions-info {
	padding-top: 20px;
	width: 100%;
}

.vimsottari-dasa-details {
	padding-top: 20px;
	width: 100%;
}

.download-chart {
	padding-top: 20px;
	width: 100%;
	font-size: 16px;
	font-family: sans-serif;
	color: #344E41;

}

button {
  background-color: #087F8C;
  color: #FFFFFF;
  font-weight: bold;
  border: none;
  padding: 11px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  outline: none;
  text-align: center;
}

.donation {
    margin: 10px;
    padding: 10px;
}

/* progress-overlay.css */

/* Overlay background */
.overlay {
  position: fixed;
  top: 0;
  left: -10;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #222; /* Better readability on light background */
  z-index: 1000;
  padding: 10px;
  text-align: center;
  border: 1px solid;
}

/* Container for progress elements */
.progress-container {
  width: 250px;
  background: #087F8C;
  padding: 20px;
  text-align: center;
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
}

/* Progress bar background */
.progress-bar {
  width: 230px;
  padding: 0px;
  background: #e7ece9;
  border-radius: 5px;
  overflow: hidden;
  margin-top: 10px;
}

/* Progress fill animation */
.progress-fill {
  width: 0%;
  height: 4vw; /* Fluid height for mobile */
  min-height: 20px; /* Ensures minimum height */
  background: #1af721;
  transition: width 0.5s ease-in-out;
}

/* Status text */
.status-text {
  margin-top: 10px;
  font-size: clamp(14px, 4vw, 16px); /* Responsive font size */
  color: white;
}

.report-cta-button {
    display: inline-block;
    background-color: #087F8C;
    color: white;
    padding: 10px 18px;
    border-radius: 6px;
    text-decoration: none;
    transition: background-color 0.3s ease;
}

</style>
